import { render, staticRenderFns } from "./FriendRequestItem.vue?vue&type=template&id=32c01c5b"
import script from "./FriendRequestItem.vue?vue&type=script&lang=js"
export * from "./FriendRequestItem.vue?vue&type=script&lang=js"
import style0 from "./FriendRequestItem.vue?vue&type=style&index=0&id=32c01c5b&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports